import { lazyWithRetry } from 'src/react-app/utilits/lazy-with-retry'

export const ActivityTimelineAsync = lazyWithRetry(() => import('./activity-timeline'))
